import { useState } from 'preact/hooks';
import { post } from '../api.js';

// kind: slobodno | zauzeto | osteceno | nestalo | placeno | neplaceno
export const Tag = ({ kind, children }) => <span class={'tag tag-' + kind}>{children}</span>;

export const PaidTag = ({ paid }) => (paid ? <Tag kind="placeno">Plaćeno</Tag> : <Tag kind="neplaceno">Nije plaćeno</Tag>);

// The office's paid switch: shows the tag, sends the opposite, reports the saved booking.
export function PaidToggle({ booking, onChange, onError }) {
  const [busy, setBusy] = useState(false);
  const toggle = async () => {
    setBusy(true);
    try {
      const r = await post(`/bookings/${booking.id}/paid`, { paid: !booking.paid });
      onChange(r.booking);
    } catch (e) {
      onError?.(e.message);
    }
    setBusy(false);
  };
  return (
    <button type="button" class="paid-toggle" aria-pressed={booking.paid ? 'true' : 'false'} aria-label={`Plaćeno: ${booking.name}`}
      disabled={busy} onClick={toggle}>
      <PaidTag paid={booking.paid} />
    </button>
  );
}
